import type { CartItem } from '../types/cartTypes';

/**
 * 判断两个商品行是否属于"同款商品"
 * 用于 Add 转 Update 逻辑
 * 
 * @param item1 - 第一个商品
 * @param item2 - 第二个商品
 * @returns 是否同款
 */
export function isSameBusinessLine(item1: CartItem, item2: CartItem): boolean {
    // 1. variant_id 必须相同
    if (item1.id !== item2.id) return false;

    // 2. selling_plan 必须相同
    const plan1 = item1.selling_plan_allocation?.selling_plan_id;
    const plan2 = item2.selling_plan_allocation?.selling_plan_id;
    if (plan1 !== plan2) return false;

    // 3. properties 必须相同 (排除内部字段)
    const props1 = filterInternalProperties(item1.properties);
    const props2 = filterInternalProperties(item2.properties);

    return arePropertiesEqual(props1, props2);
}

/**
 * 过滤掉内部字段 (以 __ 开头的字段)
 */
function filterInternalProperties(props?: Record<string, string>): Record<string, string> {
    if (!props) return {};

    const filtered: Record<string, string> = {};
    Object.keys(props).forEach(key => {
        if (!key.startsWith('__')) {
            filtered[key] = props[key];
        }
    });
    return filtered;
}

/**
 * 比较两个 properties 对象是否相等
 */
function arePropertiesEqual(
    props1: Record<string, string>,
    props2: Record<string, string>
): boolean {
    const keys1 = Object.keys(props1).sort();
    const keys2 = Object.keys(props2).sort();

    if (keys1.length !== keys2.length) return false;
    if (keys1.join(',') !== keys2.join(',')) return false;

    return keys1.every(key => props1[key] === props2[key]);
}
